module.exports = __webpack_public_path__ + "images/emoji/yellow_heart.f5e53bd946eaa832066c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/yellow_heart.png
// module id = UvWQ
// module chunks = 13